// @flow
/** @jsx h */
import { h } from 'preact';
import {
  useSalesContext,
  useSalesDispatchContext,
} from '../../../storeProviders/salesAppStore';
import { styled } from 'goober';
import { currencyFormat } from '../../directives/currencyFormat';
import { ErrorContentUi } from '../ErrorContent';
import errorIcon from '../../../assets/salesApp/error-icon.svg';
import { route } from 'preact-router';
import { salesLendersListsRoute } from '../../../alias/salesAppRoutes';

const AmountNotMatchError = () => {
  const salesState = useSalesContext();
  const {
    selectedLenderDetails,
    amount,
    checkEligibilityResponse,
    getEmiDetailsResponse,
    selectedModule,
    mobile,
    submittedAmount,
    routeDetails,
    selectedLenderId,
  } = salesState || {};
  const salesDispatch = useSalesDispatchContext();
  const { path } = routeDetails;

  const lendersResponse = mobile
    ? checkEligibilityResponse
    : getEmiDetailsResponse;
  const { emiLenders, ntbLenders } = lendersResponse || {};
  const isSingleLenderAvailable =
    (emiLenders && emiLenders.length === 1) ||
    (ntbLenders && ntbLenders.length === 1);
  const { name, minLoanAmount, maxLoanAmount, lenderId } =
    selectedLenderDetails || {};
  const finalAmount = submittedAmount || amount;
  const limitAmount =
    finalAmount > maxLoanAmount ? maxLoanAmount : minLoanAmount;
  return (
    <ErrorContentUi
      icon={errorIcon}
      title={`Sorry! ${
        selectedLenderDetails.name
      } Cardless EMI is not available for
          ₹ ${currencyFormat(finalAmount)}, ${
        finalAmount > maxLoanAmount
          ? 'Please update the amount with maximum limit as'
          : 'Please update amount with minimum of'
      }
          ₹ ${currencyFormat(limitAmount)}`}
      message={
        !isSingleLenderAvailable &&
        'Please check other available lenders or update amount to check again'
      }
      handleCloseModal={() => {
        salesDispatch({
          type: 'STORE_STATE',
          payload: {
            bottomSheetConfig: {
              showOverlay: false,
              moduleName: null,
            },
            selectedLenderId: path === '/sales-lenders-list' ? null : lenderId,
          },
        });
        !isSingleLenderAvailable &&
          path === '/sales-lender-details' &&
          window.history.back();
      }}
      handleCancelClick={() => {
        salesDispatch({
          type: 'STORE_STATE',
          payload: {
            bottomSheetConfig: {
              showOverlay: true,
              moduleName: 'AMOUNT',
            },
            selectedLenderId: lenderId,
          },
        });
      }}
      retryButtonText={
        isSingleLenderAvailable ? 'Ok' : 'Show Available Lenders'
      }
      closeButtonText='Update Amount'
      isRetryAllowed={true}
      hideCloseButton={false}
    />
  );
};

export default AmountNotMatchError;



// WEBPACK FOOTER //
// ./components/salesApp/common/AmountNotMatchError.js